import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

export const NAME = 'crimeCategory'

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.categories.forEach(category => (byId[category.id] = category))
      return byId
    case ActionTypes.FETCH_START:
      return {}
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return []
    case ActionTypes.FETCH_SUCCESS:
      return action.categories.map(category => category.id)
    default:
      return state
  }
}

const crimeCategory = combineReducers({
  byId,
  allKeys
})

export default crimeCategory
